import { FileText, ListChecks, Package, ShoppingCart } from 'lucide-react';
import { Link } from 'react-router';
import { inventoryValue } from '@/entities/item/helpers/inventory-value';
import { StatCard } from '@/shared/components/stat-card';
import { useTranslation } from '@/shared/i18n/use-translation';
import { formatCents } from '@/shared/lib/money/format-cents';
import type { useDashboard } from '../hooks/use-dashboard';

type DashboardStatsProps = {
  readonly dashboard: ReturnType<typeof useDashboard>;
};

const LINK =
  'rounded-xl outline-none transition-shadow hover:shadow-md focus-visible:ring-3 focus-visible:ring-ring/50';

export function DashboardStats({ dashboard }: DashboardStatsProps) {
  const { t } = useTranslation();
  const { items, docs, totals, openTasks } = dashboard;
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <Link to="/inventory" className={LINK}>
        <StatCard
          icon={Package}
          label={t('Products')}
          value={items?.length}
          hint={items && inventoryValue(items) > 0 ? formatCents(inventoryValue(items)) : undefined}
        />
      </Link>
      <Link to="/shopping" className={LINK}>
        <StatCard
          icon={ShoppingCart}
          label={t('To buy')}
          value={dashboard.shoppingLoaded ? totals.pendingCount : undefined}
          hint={totals.estimated > 0 ? `≈ ${formatCents(totals.estimated)}` : undefined}
        />
      </Link>
      <Link to="/tasks" className={LINK}>
        <StatCard
          icon={ListChecks}
          label={t('Tasks to do')}
          value={dashboard.tasksLoaded ? openTasks.length : undefined}
        />
      </Link>
      <Link to="/documents" className={LINK}>
        <StatCard icon={FileText} label={t('Documents')} value={docs?.length} />
      </Link>
    </div>
  );
}
